<template>
  <v-list>
    <v-list-group
      v-for="shippingHistory in shippingHistories"
      :key="shippingHistory.id"
      no-action
    >
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>
            <v-chip 
              color="#008cba" 
              dark
              class="fs12 my-2"
              small
            >{{ shippingHistory.date }}</v-chip>
            {{ shippingHistory.carrier }} ({{ shippingHistory.weight }} kg)
          </v-list-item-title>
        </v-list-item-content>
      </template>

      <ShippingHistoryItem
        v-for="shItem in shippingHistory.items"
        :key="shItem.id"
        :shItem="shItem"
      ></ShippingHistoryItem>
    </v-list-group>
  </v-list>
</template>

<script>
  // COMPONENTS
  import ShippingHistoryItem from './ShippingHistoryItem'

  export default {
    name: 'ShippingHistories',

    components: {
      ShippingHistoryItem,
    },

    props: {
      shippingHistories: Array
    }
  }
</script>